/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyGitlabIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-gitlab" */ './utils').then((m) => m.GitlabIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/gitlab/icon' },
);

const LazyGitlabSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-gitlab-search-result" */ './utils').then(
			(m) => m.GitlabSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/gitlab/search-result-icon' },
);

const LazyGitlabIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-gitlab-borderless" */ './utils').then(
			(m) => m.GitlabIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/gitlab/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const GitlabIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGitlabIconComponent />
	</Suspense>
);

export const GitlabSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGitlabSearchResultIconComponent />
	</Suspense>
);

export const GitlabIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGitlabIconBorderlessComponent />
	</Suspense>
);
